module.exports = __webpack_public_path__ + "static/img/jigou-yunnan-bottom.88616af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-yunnan-bottom.png
// module id = 0XAe
// module chunks = 2